import { useQuery } from 'react-query';
import { getPartnersReport, getTenantAccountsReport } from '~/api/reports';

export const usePartnersReport = (enabled?: boolean) =>
  useQuery('partnersReport', getPartnersReport, { enabled });

export const useTenantAccountsReport = (enabled?: boolean) =>
  useQuery('tenantAccountsReport', getTenantAccountsReport, { enabled });
